module.exports = __webpack_public_path__ + "static/company-team-5ba5e3fcca9aeec4594355e8fff8982d.jpg";